export const GROUP_GET_ALL = "V1_GROUP_GET_ALL";
export const CREATE_GROUP = "V1_CREATE_GROUP";
export const UPDATE_GROUP = "V1_UPDATE_GROUP";
export const GET_GROUP_BY_COID = "V1_GET_GROUP_BY_COID";